jQuery(document).ready(function($) {
    init_public_submit_if_needed();

    if (!is_dev) return;

    // view_evaluation(14);
    //
    // setTimeout(() => {
    //     $('#link-to-questions').click();
    // }, 2000);

    // send_evaluation_for_appointment(13, 183);
    // add_evaluation().then((elm, popup) => {
    //     setTimeout(ajax_popup_scroll_to_next_screen, 2000);
    // });
});

function init_public_submit_if_needed() {
    const $ = jQuery.noConflict();

    const elm = $('.evaluation-submit');
    if (elm.length > 0) {

        // Disable tab
        jQuery(window).keydown((e) => {
            return e.keyCode !== 9;
        });

        elm.find('.scroll-screen-wrapper').before('<div class="scroll-screen-progress"></div>');
        ajax_popup_set_scroll_screen_progress(elm);

        $('.extra-info-toggler').click(function() {
            const extraInfo = $(this);
            extraInfo.toggleClass('open');

            if (extraInfo.hasClass('open')) {
                const uid = get_unique_id();
                $(window).bind('click.close-this-info' + uid, function() {
                    $(window).unbind('click.close-this-info' + uid);
                    extraInfo.removeClass('open');
                })
            }
            return false;
        });

        $('.question-container :input').change(function() {
            const input = $(this);
            const container = input.parents('.question-container:first');

            const type = input.prop('tagName') === 'SELECT' ? 'select' : input.attr('type');

            switch (type) {
                case 'radio':
                    if (container.find('input:checked').length > 0) {
                        container.addClass('set');
                    }
                break;
                case 'text':
                    container.toggleClass('set', input.val().length > 0);
                break;
                case 'checkbox':
                    container.toggleClass('set', container.find('input:checked').length > 0);
                break;
                case 'select':
                    container.toggleClass('set', input.val() !== '0');
                break;
            }

            const screen = container.parents('.scroll-screen:first');
            screen.find('.submit-button').prop('disabled', screen.find('.question-container.required.set').length !== screen.find('.question-container.required').length);
        }).trigger('change');

        $('form').ajaxFormSubmit(() => {
            ajax_popup_scroll_to_next_screen();
            elm.doneLoading();
        }, () => {
            elm.doneLoading();
            squde_flash('Er ging iets mis. Controleer uw antwoorden.', 'alert');
        }, () => {
            elm.isLoading();
        })
    }
}

function init_evaluation_questions_sortable(elm, evaluation_id) {
    const $ = jQuery.noConflict();


    elm.find('[data-evaluation-question-selector]').evaluationQuestionSelector();

    elm.find('.sortable-wrapper').customSortable({
        onChange: () => {
            elm.find('.sortable-item:has(.section-index)').each(function(index) {
                $(this).find('.section-index').html(index + 1);
            });
            elm.find('label[for="question"] input').each(function() {
                $(this).unbind('keyup').keyup(function() {
                    const input = $(this);
                    const wrapper = input.parents('.edit-wrapper:first');
                    const name = input.val();

                    if (input[0].xhr) {
                        input[0].xhr.abort();
                    }

                    input[0].xhr = $.ajax({
                        url: '/evaluations/questions/find',
                        data: {
                            name,
                            evaluation_id: (evaluation_id || 0)
                        },
                        success: (data) => {
                            const {questions, evaluations} = data;


                            const suggestionsWrapper = wrapper.find('.suggestions ul');
                            (() => {
                                suggestionsWrapper.parent().toggle(questions.length > 0);
                                suggestionsWrapper.empty();
                                questions.forEach((question) => {
                                    const li = $('<li></li>');

                                    const a = $('<a></a>');
                                    a.html(question.name);

                                    a.click(() => {
                                        const str = a.html();
                                        input.val(str).trigger('keyup');

                                        const editWrapper = a.parents('.edit-wrapper:first');
                                        const textArea = editWrapper.find('textarea[data-tinymce-id]');
                                        const typeSelect = editWrapper.find('select.type-select');
                                        const select = editWrapper.find('[data-evaluation-question-option-group-selector]');

                                        typeSelect.val(question.type).trigger('change');
                                        select.val(question.option_group_id).trigger('change');

                                        try {
                                            tinymce.get(textArea.attr('id')).setContent(question.description);
                                        } catch(e) {
                                            textArea.html(question.description);
                                        }

                                        return false;
                                    });

                                    li.html(a);

                                    suggestionsWrapper.append(li);
                                });
                            })();

                            const usageInfoWrapper = wrapper.find('.usage-info ul');
                            (() => {
                                usageInfoWrapper.parent().toggle(evaluations.length > 0);

                                usageInfoWrapper.empty();

                                evaluations.forEach((evaluation) => {
                                    const li = $('<li></li>');

                                    const a = $('<a></a>');
                                    a.html(evaluation.name);

                                    a.click(() => {
                                        view_evaluation(evaluation.id);
                                        return false;
                                    });

                                    li.html(a);

                                    usageInfoWrapper.append(li);
                                });
                            })();

                            suggestionsWrapper.parents('.callout').toggle((questions.length + evaluations.length) > 0);
                        }
                    });
                }).trigger('keyup');
            });

            init_question_selectors(elm);
        }
    });

    elm.find('.sortable-item')
        .bind('afterClone', function(event) {
            const item = $(event.target);
            const hasChildren = item.find('.sortable-wrapper').length > 0;
            if (hasChildren) {
                item.find('.sortable-item').each(function() {
                    $(this).trigger('afterClone');
                })
            } else {
                const selector = item.find('[data-evaluation-question-selector]');
                selector.prev().remove();
                selector
                    .removeAttr('data-uid')
                    .unbind('change.specialSelector')
                    .unbind('change.specialSelectorSearcher')
                    .removeClass('has-special-selector')
                    .attr('data-current-value', '-1')
                    .evaluationQuestionSelector()
                    .trigger('change.update_not_in_list')
                ;
            }
        })
        .bind('willRemove', function(event) {
            const item = $(event.target);
            const hasChildren = item.find('.sortable-wrapper').length > 0;
            if (hasChildren) {
                item.find('.sortable-item').each(function() {
                    $(this).trigger('willRemove');
                })
            } else {
                const selector = item.find('[data-evaluation-question-selector]');
                selector.attr('data-current-value', -1);
                selector.trigger('change.update_not_in_list');
            }
        });

    elm.find('[data-evaluation-question-selector]')
        .unbind('change.update_not_in_list')
        .bind('change.update_not_in_list', function() {
        setTimeout(() => {
            const chosenIds = [];
            elm.find('[data-evaluation-question-selector]').each(function() {
                const val = parseInt($(this).prev().attr('data-current-value'));
                if (val > 0 && !chosenIds.includes(val)) {
                    chosenIds.push(val);
                }
            });
            elm.find('[data-evaluation-question-selector]').each(function() {
                const selector = $(this);
                const val = parseInt(selector.prev().attr('data-current-value'));
                const allButThis = _.clone(chosenIds)
                    .filter((v) => v !== val);
                const id = selector.attr('data-uid');
                const filterKeyName = `${id}-f`;
                selector.attr('data-filter-key', filterKeyName);
                const wrapper = selector.parent().parent();
                wrapper.find('.not-filter').remove();
                allButThis.forEach((id) => {
                    const input = $(`<input data-name="not_in[]" type="hidden" class="not-filter" data-${filterKeyName}-filter value="${id}" />`);
                    wrapper.append(input);
                })
            })
        }, 100);
    }).trigger('change.update_not_in_list');
}

function add_evaluation(vars) {
    const $ = jQuery.noConflict();

    if(typeof vars === 'function') {
        vars = {callback: vars};
    }

    return new Promise((resolve, reject) => {
        $.squdeAjaxPopup({
            url: '/evaluations/add',
            onOpen: function (elm, popup) {
                init_evaluation_questions_sortable(elm);

                elm.find('form').ajaxFormSubmit(function(data){
                    popup.close();
                    squde_reload_for_flashes();
                    reload_location_if_needed();

                    if(vars && vars.callback) {
                        vars.callback(data, elm, popup);
                    }
                    if (!document.closeWindow) open_new_object(view_evaluation, data);
                }.bind([elm,popup]), function(xhr, status, error) {
                    $('body').doneLoading();
                    squde_flash("Er ging iets mis bij het opslaan.", "alert");
                }.bind([elm,popup]), function() {
                    $('body').isLoading('dark');
                });

                resolve(elm, popup);
            }
        });
    });
}

function simply_add_evaluation(vars) {
    add_evaluation(vars);
    return false;
}



/**
 * Almost does the same as deleting, only sets enabled to 0
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function disable_evaluation(id, name) {
    const $ = jQuery.noConflict();
    name = decodeURI(name);

    confirm("Weet u zeker dat u \""+name+"\" wilt deactiveren?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: `/evaluations/disable/${id}`,
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'evaluation\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}

/**
 * Almost the same as disabling, but enabling
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function enable_evaluation(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    $('body').isLoading('dark');
    $.ajax({
        url: `/evaluations/enable/${id}`,
        type: "POST",
        success: function(data) {
            var row = $('[data-object-type=\'evaluation\'][data-id=\''+id+'\'');
            row.find('.visual-icon-activate').removeClass('visual-icon-activate').addClass('visual-icon-deactivate');
            row.find('.visual-icon-deactivate').parent().attr('onclick', 'return disable_evaluation('+id+',"'+name+'");');
            $('body').doneLoading();
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
    return false;
}

/**
 * Obvious function name. deletes the evaluation that has been selected
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function delete_evaluation(id, name) {
    name = decodeURI(name);
    custom_delete_with_confirmation('/evaluations/delete/' + id,id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'evaluation');

    return false;
}

/**
 * This function opens the evaluation-popup, filled with evaluation data.
 * You can set a callback function in vars for when the evaluation gets
 * updated.
 *
 * @param id
 * @param vars
 * @returns {boolean}
 */
function view_evaluation(id, vars) {
    const $ = jQuery.noConflict();

    if(typeof vars == 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: '/evaluations/view/'+id,
        onOpen: function(elm, popup) {
            init_evaluation_questions_sortable(elm, id);

            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('evaluation', id);
                $('body').doneLoading();

                squde_reload_for_flashes();
                if (document.closeWindow) popup.close();

                if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function copy_evaluation(id) {
    const $ = jQuery.noConflict();
    $('body').isLoading();
    $.ajax({
        url: '/evaluations/copy/' + id,
        type: "POST",
        success: function(newObject) {
            $('body').doneLoading();


            reload_location_if_needed(true, () => {
                const fn = 'view_evaluation(' + newObject.id + ')';
                eval(fn);
            });
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis.", "alert");
        }
    });
    return false;
}

function view_evaluation_details_for_appointment(appointment_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/evaluations/details/' + appointment_id,
        onOpen: function(elm, popup) {

            if (elm.find('[data-evaluation-selector]').length > 0) {
                elm.find('[data-evaluation-selector]').evaluationSelector();
            }
            initiate_evaluation_statistics(elm);

            elm.find('form').ajaxFormSubmit(function(data){
                $('body').doneLoading();

                squde_reload_for_flashes();
                reload_location_if_needed(document.closeWindow);
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function view_answers(appointment_group_id, contact_id) {

    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/evaluations/answers/' + appointment_group_id + '/' + contact_id,
        onOpen: function(elm, popup) { }
    });
    return false;
}

function initiate_evaluation_statistics(parent) {
    const $ = jQuery.noConflict();
    if (parent.length === 0) {
        return;
    }
    parent.find('[data-evaluation-scores]').each(function() {
        const elm = $(this);

        const elmId = elm.attr('id');

        let debouncedFn;

        const filterStatistics = () => {

            if (debouncedFn) {
                debouncedFn.cancel();
            }

            debouncedFn = _.debounce(() => {
                if (elm[0].evaluationsRequest) elm[0].evaluationsRequest.abort();

                const form = elm.find('form');
                const data = form.serializeJSON();

                if (!data.owner) {
                    return;
                }

                if (data.dateRange) {
                    data.dateRange.from = data.dateRange.from.split('-').reverse().join('-');
                    data.dateRange.to = data.dateRange.to.split('-').reverse().join('-');
                }

                const args = {
                    dateRange: data.dateRange,
                    owner: data.owner,
                };
                for (const key in data) {
                    const value = data[key];
                    if (typeof value !== 'object' && parseInt(value) > 0) {
                        args[key] = parseInt(value);
                    }
                }
                elm.isLoading();

                elm[0].evaluationsRequest = $.get('/evaluations/statistics', args, function(data) {
                    elm.doneLoading();
                    elm.find('.has-scores').toggle(!!data.general);
                    elm.find('.has-no-scores').toggle(!data.general);
                    if (!data.general) return;

                    const formatNumber = (no) => {
                        no = parseFloat(no);
                        const str = (Math.round(no) / 10).toString();
                        if (str.split('.').length === 1) {
                            return `${str}.0`;
                        }
                        return str;
                    }
                    elm.find('.general-score').html(formatNumber(data.general));
                    elm.find('.count').html(data.count);
                    elm.find('.if-count-not-1').toggle(parseInt(data.count) !== 1);

                    elm.find('.categories-wrapper').find('.category-wrapper:not(:nth-child(1))').remove();

                    data.categories.forEach((average, index) => {
                        const elmIndex = index + 1;
                        let wrapper = elm.find('.categories-wrapper').find(`.category-wrapper:nth-child(${elmIndex})`);
                        if (wrapper.length === 0) {
                            wrapper = elm.find('.categories-wrapper').find(`.category-wrapper:nth-child(1)`).clone(true, true);
                            elm.find('.categories-wrapper').append(wrapper);
                        }
                        // console.log(average);

                        wrapper.find('.category-name').html(average.category.name);
                        wrapper.find('.category-score').html(formatNumber(average.score));

                        wrapper.find('.questions-wrapper').find('.question-wrapper:not(:nth-child(1))').remove();
                        average.questions.forEach((questionAverage, index) => {
                            const elmIndex = index + 1;
                            let qWrapper = wrapper.find('.questions-wrapper').find(`.question-wrapper:nth-child(${elmIndex})`);
                            if (qWrapper.length === 0) {
                                qWrapper = wrapper.find('.questions-wrapper').find(`.question-wrapper:nth-child(1)`).clone(true, true);
                                wrapper.find('.questions-wrapper').append(qWrapper);
                            }

                            let name = questionAverage.question.name;
                            if (questionAverage.question.teacher) {
                                name = `${questionAverage.question.name}<br />(${questionAverage.question.teacher.messageName})`;
                            }

                            qWrapper.find('.question-name').html(name);
                            qWrapper.find('.question-count').html(questionAverage.count);
                            qWrapper.find('.question-score').html(formatNumber(questionAverage.score));
                        });
                    });

                    const printSelect = elm.find('select[name="print_options"]');
                    printSelect.empty();
                    data.printOptions.forEach((option) => {
                        printSelect.append(`<option value="${option.url}">${option.name}</option>`);
                    });
                    elm.find('.print-this-layout').unbind('click').click(function() {
                        let url = printSelect.val();
                        if(window.pressed('alt')) {
                            window['pressed_keys'] = [];
                            url += '?stream=true';
                        }
                        window.open(url);
                    })
                });
            }, 500);
            debouncedFn();
        };

        parent
            .off(`openTab.evaluationStatistics-${elmId}`)
            .on(`openTab.evaluationStatistics-${elmId}`, async function(event, link, initial) {
            if (link === elmId && initial) {
                const [type, ownerId] = elm.attr('data-owner').split(':');

                elm.isLoading();
                const htmlContents = await $.get(`/evaluations/statisticsView/${type}/${ownerId}`);
                elm.html(htmlContents);

                elm.find('[data-contact-selector]').contactSelector();
                elm.find('[data-company-selector]').companySelector();
                elm.find('[data-course-selector]').courseSelector();
                elm.find('[data-evaluation-selector]').evaluationSelector();

                elm.find('select, input[data-datepicker]').unbind('change.statistics').bind('change.statistics', filterStatistics);
                filterStatistics();
            }
        });
    })

}

/**
 * Delete the submission
 *
 * @param appointment_group_id
 * @param contact_id
 * @param name
 * @returns {boolean}
 */
function delete_evaluation_submission(appointment_group_id, contact_id, name) {
    name = decodeURI(name);
    custom_delete_with_confirmation( `/evaluations/delete-submission/${appointment_group_id}/${contact_id}`, `${appointment_group_id}_${contact_id}`,"Weet u zeker dat u de evaluatie van \""+name+"\" wilt verwijderen?",'evaluationsubmission');

    return false;
}
